import React, { useState } from 'react'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../Store/CourseStore'
import CalendarStore from '../../../../../../Modules/Calendar/Store/CalendarStore'
import EnrollmentRequestModal from '../EnrollmentRequestModal'
import ClassTimings from '../../../../../../Modules/ClassTimings/ClassTimings'
import { getNextClass } from '../../../../Helpers/Timings'
import Anonymous from './Components/Anonymous'
import RequestedEnrollment from './Components/RequestedEnrollment'
import EnrollmentCalendar from './Components/EnrollmentCalendar'
import EnrollmentBatches from './Components/EnrollmentBatches'

const Timings = ({ restricted }) => {
  const [showModal, toggleModal] = useState(false)

  return restricted ? (
    <p>Section restricted for current viewing mode</p>
  ) : (
    <Subscribe to={[CourseStore, CalendarStore]}>
      {(
        { state, initiateEnrollmentRequest, deleteRegistration, enroll },
        { getPickedSlots },
      ) => {
        const courseCompleted = Boolean(
          (state.enrollments || []).find((enr) => enr.status === 'APPROVED') &&
            !getNextClass(state.enrollments),
        )

        return (
          <div className='timings'>
            {state.userType === 'anonymous' ? (
              <Anonymous />
            ) : state.userType === 'notEnrolled' ||
              (courseCompleted && state.userType !== 'teacher') ? (
              state.pendingEnrollmentRequest ? (
                <RequestedEnrollment
                  pendingEnrollmentRequest={state.pendingEnrollmentRequest}
                  deleteRegistration={deleteRegistration}
                />
              ) : (
                <>
                  {state.isGroupCourse ? (
                    <EnrollmentBatches
                      enroll={enroll}
                      batches={state.batches}
                      name={state.name}
                      teacher={state.teacher.name}
                    />
                  ) : (
                    <EnrollmentCalendar
                      toggleModal={toggleModal}
                      initiateEnrollmentRequest={initiateEnrollmentRequest}
                      getPickedSlots={getPickedSlots}
                      livDemyID={state.livDemyID}
                      noOfClasses={state.noOfClasses}
                      name={state.name}
                    />
                  )}
                </>
              )
            ) : (
              <ClassTimings userType={state.userType} />
            )}
            {showModal && (
              <EnrollmentRequestModal close={() => toggleModal(false)} />
            )}
          </div>
        )
      }}
    </Subscribe>
  )
}

export default Timings
